import { render, staticRenderFns } from "./LayoutNavbar.vue?vue&type=template&id=28df6cf6&"
import script from "./LayoutNavbar.vue?vue&type=script&lang=js&"
export * from "./LayoutNavbar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cognatis/api/frontend/foundation/dev/webapp/vue-project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('28df6cf6', component.options)
    } else {
      api.reload('28df6cf6', component.options)
    }
    module.hot.accept("./LayoutNavbar.vue?vue&type=template&id=28df6cf6&", function () {
      api.rerender('28df6cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/LayoutNavbar.vue"
export default component.exports